<template>
  <div class="t-modal-reviews">
    <div class="t-modal-reviews__title t-title-bold" v-html="props.title"></div>
    <div class="t-modal-reviews__container">
      <div class="t-reviews__row">
        <div class="t-reviews__left">
          <div ref="reviewsImg" class="t-reviews__img t-modal-reviews__img" :class="'id-' + props.index">
            <span v-if="data.name">{{ data.name.split('')[0] }}</span>
            <span v-if="data.surname">{{ data.surname.split('')[0] }}</span>
            <img v-if="props.img" :src="props.img" :alt="data.name" />
          </div>
          <div class="t-reviews__wrap">
            <div class="t-reviews__name">{{ data.name }} {{ data.surname }}</div>
            <div class="t-modal-reviews__row">
              <div class="t-reviews__company">{{ data.company }}</div>
              <div class="t-reviews__location t-modal-reviews__location">{{ data.location }}</div>
            </div>
          </div>
        </div>
        <div class="t-reviews__date t-modal-reviews__date">{{ data.date }}</div>
      </div>
      <h4 class="t-reviews__subtitle" v-html="data.subtitle"></h4>
      <div class="t-reviews__desc" v-html="data.desc"></div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['props'],
  data() {
    return {
      data: {
        name: null,
        surname: null,
        company: null,
        location: null,
        desc: null,
        subtitle: null,
        date: null,
      },
      fields: ['name', 'surname', 'company', 'location', 'desc', 'subtitle', 'date'],
    }
  },
  methods: {
    ...mapActions('modal', ['modalClose']),
  },
  mounted() {
    // по другому не получилось передать данные из twig во vue,
    // чтобы теги внутри текста отработали (<br> например, и кавычки разные)
    for (let i = 0; i < this.fields.length; i++) {
      this.data[this.fields[i]] = document.querySelector('.js-' + this.fields[i] + '-' + this.props.index).innerHTML
    }

    // определение цвета, если нет картинки (пока есть 3 цвета по порядку)
    let reviewsImg = this.$refs.reviewsImg
    let classId = parseInt(reviewsImg.classList.value.split('id-')[1]) % 3
    reviewsImg.classList.add('_' + classId)
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/reviews.vue